// extracted by mini-css-extract-plugin
export default {"ascDesc":"styles_ascDesc__Ee3wo","button":"styles_button__WkcVt","active":"styles_active__BgVqW","text":"styles_text__DO2+J"};